import React from 'react';
import { ChakraProvider, theme } from '@chakra-ui/react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Homev3 from './componenti/v3/homev3';

function App() {
  return (
    <BrowserRouter>
      <ChakraProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Homev3 />} />
          <Route path="home" element={<Homev3 />} />
        </Routes>
      </ChakraProvider>
    </BrowserRouter>
  );
}

export default App;
